import angular from 'angular';

angular.module('cloudX').directive('moveCaretOnFocus', [
  '$timeout',
  function($timeout) {
    function setCaretPosition(elem, caretPos) {
      if (!elem) return;
      if (elem.createTextRange) {
        var range = elem.createTextRange();
        range.move('character', caretPos);
        range.select();
      } else if (elem.selectionStart) {
        elem.setSelectionRange(caretPos, caretPos);
      }
    }

    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var focusedElement = null;
        var pos = parseInt(scope.$eval(attrs.moveCaretOnFocus) || attrs.moveCaretOnFocus);

        var onFocus = function() {
          var self = this;
          if (focusedElement !== self) {
            focusedElement = self;
            $timeout(function() {
              if (focusedElement) setCaretPosition(focusedElement, pos);
            }, 10);
          }
        };
        var onBlur = function() {
          focusedElement = null;
        };

        element.on('focus', onFocus);
        element.on('blur', onBlur);

        //Cleanup events if the element is destroyed
        element.on('$destroy', function() {
          element.off('focus', onFocus);
          element.off('blur', onBlur);
          focusedElement = null;
        });
      },
    };
  },
]);
